export function buildSummaryReportParams({
  since,
  until,
  from,
  to,
  labelIds,
  excludeLabelIds,
  inboxIds,
  teamIds,
  agentIds,
  channelTypes,
  episodeResult,
  receiptType,
  tagPresence,
  resolutionMethod,
  statusAtPeriodEnd,
  reopening,
  transfers,
  humanResponse,
  comparisonPeriods,
} = {}) {
  const params = {};
  const sinceValue = since ?? from;
  const untilValue = until ?? to;
  // Only set when present so callers can safely spread scope filters
  // without wiping an already-set since/until.
  if (sinceValue !== undefined && sinceValue !== null && sinceValue !== '') {
    params.since = sinceValue;
  }
  if (untilValue !== undefined && untilValue !== null && untilValue !== '') {
    params.until = untilValue;
  }
  if (labelIds?.length) params.label_ids = labelIds;
  if (excludeLabelIds?.length) params.exclude_label_ids = excludeLabelIds;
  if (inboxIds?.length) params.inbox_ids = inboxIds;
  if (teamIds?.length) params.team_ids = teamIds;
  if (agentIds?.length) params.agent_ids = agentIds;
  if (channelTypes?.length) params.channel_types = channelTypes;
  if (episodeResult && episodeResult !== 'all') {
    params.episode_result = episodeResult;
  }
  if (receiptType && receiptType !== 'all') {
    params.receipt_type = receiptType;
  }
  if (tagPresence && tagPresence !== 'all') {
    params.tag_presence = tagPresence;
  }
  if (resolutionMethod && resolutionMethod !== 'all') {
    params.resolution_method = resolutionMethod;
  }
  if (statusAtPeriodEnd && statusAtPeriodEnd !== 'all') {
    params.status_at_period_end = statusAtPeriodEnd;
  }
  if (reopening && reopening !== 'all') {
    params.reopening = reopening;
  }
  if (transfers && transfers !== 'all') {
    params.transfers = transfers;
  }
  if (humanResponse && humanResponse !== 'all') {
    params.human_response = humanResponse;
  }
  if (comparisonPeriods?.length) {
    params.comparison_periods = JSON.stringify(
      comparisonPeriods.map(period => ({
        since: period.from ?? period.since,
        until: period.to ?? period.until,
      }))
    );
  }
  return params;
}

export function pickScopeFilters({
  labelIds,
  excludeLabelIds,
  inboxIds,
  teamIds,
  agentIds,
  channelTypes,
  tagPresence,
  resolutionMethod,
  statusAtPeriodEnd,
  reopening,
  transfers,
  humanResponse,
} = {}) {
  return {
    labelIds,
    excludeLabelIds,
    inboxIds,
    teamIds,
    agentIds,
    channelTypes,
    tagPresence,
    resolutionMethod,
    statusAtPeriodEnd,
    reopening,
    transfers,
    humanResponse,
  };
}
